import { serviceOperationApi } from "./api";

export async function fetchTableItems({ accessToken, tableName, countryId }) {
  const isExt = tableName === "deposito_destino";
  const res = await serviceOperationApi.get(isExt ? "/DataExt" : "/Data", {
    params: { table: tableName, country_id: countryId },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}